/**
 * @generated SignedSource<<332e77bd14aa59c4322eee4b3b3f9a8a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserProductGroup = "plus" | "pro" | "%future added value";
export type UserProductId = "dom7_plus" | "dom7_pro_annual" | "dom7_pro_monthly" | "%future added value";
export type UserProductStore = "android" | "ios" | "%future added value";
export type UserProductType = "NON_CONSUMABLE" | "PAID_SUBSCRIPTION" | "%future added value";
export type User_Role = "ADMIN" | "ANON" | "USER" | "%future added value";
export type UserSongsQueryQuery$variables = {};
export type UserSongsQueryQuery$data = {
  readonly viewer: {
    readonly errors: ReadonlyArray<{
      readonly __typename: "AuthError";
      readonly message: string;
    }>;
    readonly user: {
      readonly doPromptFeedback: boolean;
      readonly id: string;
      readonly products: ReadonlyArray<{
        readonly expiresAt: string | null;
        readonly isVerified: boolean;
        readonly productGroup: UserProductGroup;
        readonly productId: UserProductId;
        readonly productStore: UserProductStore;
        readonly productType: UserProductType;
      }>;
      readonly roles: ReadonlyArray<User_Role>;
      readonly " $fragmentSpreads": FragmentRefs<"UserSongsList_songs" | "UserSongsList_user">;
    } | null;
  } | null;
};
export type UserSongsQueryQuery = {
  response: UserSongsQueryQuery$data;
  variables: UserSongsQueryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "doPromptFeedback",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roles",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "UserProduct",
  "kind": "LinkedField",
  "name": "products",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "productGroup",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "productStore",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "productType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "productId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expiresAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "AuthError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2147483647
  }
],
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "user",
    "storageKey": null
  },
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isOwner",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canEdit",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "didAccept",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserSongsQueryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryResult",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserSongsList_user"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserSongsList_songs"
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UserSongsQueryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryResult",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "boxIntervals",
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailConfirmed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTestEvent",
                "kind": "LinkedField",
                "name": "testHistory",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "song",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "eventType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "time",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "UserSongsConnection",
                "kind": "LinkedField",
                "name": "songs",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserSongsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Song",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "artist",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tags",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SongPermission",
                            "kind": "LinkedField",
                            "name": "permissions",
                            "plural": true,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SongPermission",
                            "kind": "LinkedField",
                            "name": "viewerPermission",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mongoVersion",
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": "songs(first:2147483647)"
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "UserSongs_songs",
                "kind": "LinkedHandle",
                "name": "songs"
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6bb22676467b19386305f409d72a6810",
    "id": null,
    "metadata": {},
    "name": "UserSongsQueryQuery",
    "operationKind": "query",
    "text": "query UserSongsQueryQuery {\n  viewer {\n    user {\n      id\n      doPromptFeedback\n      ...UserSongsList_user\n      ...UserSongsList_songs\n      roles\n      products {\n        productGroup\n        productStore\n        productType\n        productId\n        isVerified\n        expiresAt\n      }\n    }\n    errors {\n      __typename\n      message\n    }\n  }\n}\n\nfragment DeleteSong_song on Song {\n  id\n  title\n  artist\n  mongoVersion\n  permissions {\n    user\n    email\n    isOwner\n    canEdit\n    didAccept\n  }\n}\n\nfragment ShareSongPDF_song on Song {\n  id\n  title\n  artist\n  mongoVersion\n  permissions {\n    user\n    email\n    isOwner\n    canEdit\n    didAccept\n  }\n}\n\nfragment SongAddShare_song on Song {\n  id\n  title\n  artist\n  mongoVersion\n  permissions {\n    user\n    email\n    isOwner\n    canEdit\n    didAccept\n  }\n}\n\nfragment SongDeleteShare_permission on SongPermission {\n  user\n  email\n  isOwner\n  canEdit\n  didAccept\n}\n\nfragment SongDeleteShare_song on Song {\n  id\n  title\n  artist\n}\n\nfragment SongListItem_song on Song {\n  id\n  title\n  artist\n  tags\n  permissions {\n    user\n    email\n    isOwner\n    canEdit\n    didAccept\n  }\n  viewerPermission {\n    user\n    email\n    isOwner\n    canEdit\n    didAccept\n  }\n}\n\nfragment SongManageShareSharee_song on Song {\n  ...SongRejectShare_song\n  id\n  permissions {\n    user\n    email\n    isOwner\n    canEdit\n    didAccept\n  }\n  viewerPermission {\n    user\n    email\n    isOwner\n    canEdit\n    didAccept\n  }\n}\n\nfragment SongManageShare_song on Song {\n  ...SongAddShare_song\n  ...ShareSongPDF_song\n  ...SongUpdateShare_song\n  ...SongDeleteShare_song\n  id\n  permissions {\n    ...SongUpdateShare_permission\n    ...SongDeleteShare_permission\n    user\n    email\n    isOwner\n    canEdit\n    didAccept\n  }\n}\n\nfragment SongManageShare_user on User {\n  id\n  email\n}\n\nfragment SongRejectShare_song on Song {\n  id\n  title\n  viewerPermission {\n    user\n    email\n    isOwner\n    canEdit\n    didAccept\n  }\n}\n\nfragment SongUpdateShare_permission on SongPermission {\n  user\n  email\n  isOwner\n  canEdit\n  didAccept\n}\n\nfragment SongUpdateShare_song on Song {\n  id\n  permissions {\n    user\n    email\n    isOwner\n    canEdit\n    didAccept\n  }\n}\n\nfragment UserSongsList_songs on User {\n  songs(first: 2147483647) {\n    edges {\n      node {\n        ...SongListItem_song\n        ...SongManageShare_song\n        ...SongManageShareSharee_song\n        ...DeleteSong_song\n        ...ShareSongPDF_song\n        id\n        title\n        artist\n        tags\n        permissions {\n          user\n          email\n          isOwner\n          canEdit\n          didAccept\n        }\n        viewerPermission {\n          user\n          email\n          isOwner\n          canEdit\n          didAccept\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment UserSongsList_user on User {\n  id\n  boxIntervals\n  email\n  emailConfirmed\n  testHistory {\n    song\n    eventType\n    time\n  }\n  ...SongManageShare_user\n}\n"
  }
};
})();

(node as any).hash = "90746f61cfa556ffe7c23834585149f0";

export default node;
